import { useAuth } from '../utils/auth/authContext'

export const useAccessPermissions = () => {
  const { accessPermissions } = useAuth();

  return { accessPermissions };
};